export enum DirectoryType {
	user = 'user',
	unknown = 'unknown',
}
